import Api from "./baseApi";

export default {
  getBlogs: () => Api.get("/api/blogs"),
  getBlog: (id) => Api.get(`/api/blogs/${id}`),
  postBlog: (blog) => Api.post("/api/blogs", blog),
  putBlog: (id, blog) => Api.put(`/api/blogs/${id}`, blog),
  updateBlogStatus: (id, isActive) => Api.patch(`/api/blogs/${id}/status`, { isActive }),
  deleteBlog: (id) => Api.delete(`/api/blogs/${id}`)
};
